var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationOutlined = function SvgLocationOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "location_outlined_svg__a",
    d: "M12 2c4.693 0 8 3.31 8 8.557 0 .935-.208 1.919-.597 2.945-.629 1.659-1.713 3.39-3.123 5.147a36 36 0 0 1-3.294 3.565l-.16.15-.826.739-.665-.593-.161-.147-.551-.524-.427-.424a36 36 0 0 1-2.476-2.766c-1.41-1.757-2.494-3.488-3.123-5.147-.39-1.026-.597-2.01-.597-2.945C4 5.31 7.307 2 12 2m0 2c-3.588 0-6 2.414-6 6.557 0 .672.158 1.422.467 2.236.543 1.432 1.522 2.997 2.813 4.605.742.924 1.54 1.804 2.337 2.61l.383.38.383-.38a34 34 0 0 0 2.337-2.61c1.29-1.608 2.27-3.173 2.813-4.605.309-.814.467-1.564.467-2.236C18 6.414 15.588 4 12 4m0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "location_outlined_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#location_outlined_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#location_outlined_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLocationOutlined;